export default "__VITE_PUBLIC_ASSET__65eb6836__"